/* TWRD UGC strip: afspil kun naar striben er synlig, pause ellers.
   muted saettes ogsaa via JS, saa iOS tillader autoplay. Ingen controls,
   ingen lyd, ingen klik. */
(function () {
  'use strict';

  function init() {
    var strips = document.querySelectorAll('[data-twrd-ugc]');
    if (!strips.length) return;

    for (var i = 0; i < strips.length; i++) {
      setup(strips[i]);
    }
  }

  function setup(strip) {
    if (strip.__twrdUgc) return;
    strip.__twrdUgc = true;

    var videos = strip.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      v.muted = true;
      v.defaultMuted = true;
      v.volume = 0;
      v.controls = false;
      v.removeAttribute('controls');
    }

    var track = strip.querySelector('.twrd-ugc__track');

    function hydrate() {
      for (var j = 0; j < videos.length; j++) {
        var source = videos[j].getAttribute('data-src');
        if (!source || videos[j].getAttribute('src')) continue;
        videos[j].setAttribute('src', source);
        videos[j].load();
      }
    }

    function setPlaying(on) {
      if (on) hydrate();
      for (var j = 0; j < videos.length; j++) {
        if (on) {
          var p = videos[j].play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          videos[j].pause();
        }
      }
      /* respekter prefers-reduced-motion: marqueen forbliver pauset */
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track) track.style.animationPlayState = on && !reduced ? 'running' : 'paused';
    }

    if (!('IntersectionObserver' in window)) {
      setPlaying(true);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var k = 0; k < entries.length; k++) {
          setPlaying(entries[k].isIntersecting);
        }
      },
      { rootMargin: '400px 0px' }
    );
    io.observe(strip);
    strip.__twrdUgcObserver = io;
    strip.__twrdUgcStop = function () { setPlaying(false); };
  }

  /* Temaeditoren fjerner sektionen uden at fortaelle observeren det.
     Uden dette bliver hver reload til en observer og fire videoer mere. */
  function teardown(scope) {
    var strips = (scope || document).querySelectorAll('[data-twrd-ugc]');
    for (var i = 0; i < strips.length; i++) {
      var s = strips[i];
      if (s.__twrdUgcObserver) {
        s.__twrdUgcObserver.disconnect();
        s.__twrdUgcObserver = null;
      }
      if (s.__twrdUgcStop) {
        s.__twrdUgcStop();
        s.__twrdUgcStop = null;
      }
      s.__twrdUgc = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    teardown(e.target);
  });
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
